import _ from 'underscore';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';
import BaseTargetViewModel from '@bingads-webui-campaign-legacy/base-targets/viewmodel/baseTargets';
import targetConstants from '@bingads-webui-campaign-legacy/base-targets/viewmodel/targetConstants';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class NativeAdViewModel extends BaseTargetViewModel {
  constructor(options = {}) {
    super(_.defaults({
      targetTypePrefix: 'NativeAdType',
      targetRowKeys: targetConstants.rowKeys.NativeAd,
      criterionType: 'NativeAd',
      criterionTypeTarget: 'Target',
      /*TODO [lizho] MT doesn't return errors when native ad bid adjustment is out of range. Use AgeTarget error number for now in order to do UI validaiton, will change
      to use correct one after MT supports range validaiton*/
      MTBidAdjustmentErrorCode: 'CampaignServiceInvalidAgeTargetBidAdjustment',
      MTBidAdjustmentErrorNumber: '2936',
      targetPopupId: 'pop_BA_NativeAd_BidAdj',
    }, options));

    koSchema.properties(this);

    // Override certain properties if Native ads rebranding is enabled
    if (this.options.isNativeAdsRebrandingEnabled) {
      this.targetHeader = i18n.getString('AdvancedTargeting_AudienceAdsText');
      if (this.rows && this.rows.length > 0) {
        this.rows[0].targetName = i18n.getString('AdvancedTargeting_AudienceAdsBids');
      }
    }
  }

  getValues() {
    let rowBidAdjustment;

    if ((this.options.scenario === 'adgroup-create' || this.options.scenario === 'adgroup-settings') && this.useCampaignSettings()) {
      rowBidAdjustment = null;
    } else {
      rowBidAdjustment = Number(this.NativeAdTypeNativeAdsBidsRow.bidAdjustmentValue()) * this.NativeAdTypeNativeAdsBidsRow.selectedBidAdjustmentOption();
    }

    return {
      NativeBidAdjustment: rowBidAdjustment,
    };
  }
}
